import * as i1 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, select, StoreModule } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { isEmpty } from 'lodash';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
var AppAlertActionTypes = /*#__PURE__*/function (AppAlertActionTypes) {
  AppAlertActionTypes["ClearAlerts"] = "[AppAlert] Clear Alerts";
  AppAlertActionTypes["DeleteAlert"] = "[AppAlert] Delete AppAlert";
  AppAlertActionTypes["UpdateAlert"] = "[AppAlert] Update AppAlert";
  AppAlertActionTypes["UpsertAlert"] = "[AppAlert] Upsert AppAlert";
  AppAlertActionTypes["UpsertAlerts"] = "[AppAlert] Upsert Alerts";
  return AppAlertActionTypes;
}(AppAlertActionTypes || {});
const clearAlerts = createAction(AppAlertActionTypes.ClearAlerts);
const deleteAlert = createAction(AppAlertActionTypes.DeleteAlert, props());
const updateAlert = createAction(AppAlertActionTypes.UpdateAlert, props());
const upsertAlert = createAction(AppAlertActionTypes.UpsertAlert, props());
const upsertAlerts = createAction(AppAlertActionTypes.UpsertAlerts, props());
var AppAlertType = /*#__PURE__*/function (AppAlertType) {
  AppAlertType["profile"] = "profile";
  AppAlertType["account"] = "account";
  AppAlertType["subscriber"] = "subscriber";
  AppAlertType["device"] = "device";
  AppAlertType["page"] = "page";
  AppAlertType["reward"] = "reward";
  AppAlertType["connectionsCard"] = "connectionsCard";
  return AppAlertType;
}(AppAlertType || {});
const alertsFeatureKey = 'alerts';
const adapter = createEntityAdapter({
  selectId: alert => `${alert.key}_${alert.uniqueAlertId}`
});
const initialState = adapter.getInitialState({
  // additional entity state properties
});
const createAlertReducer = createReducer(initialState, on(clearAlerts, state => adapter.removeAll(state)), on(deleteAlert, (state, {
  id
}) => adapter.removeOne(id, state)), on(upsertAlert, (state, {
  alert
}) => adapter.upsertOne(alert, state)), on(upsertAlerts, (state, {
  alerts
}) => adapter.upsertMany(alerts, state)), on(updateAlert, (state, {
  id,
  changes
}) => adapter.updateOne({
  id,
  changes
}, state)));
const alertReducer = (state, action) => {
  return createAlertReducer(state, action);
};
const {
  selectEntities
} = adapter.getSelectors();
const selectAlertState = createFeatureSelector(alertsFeatureKey);
const alertEntities = createSelector(selectAlertState, selectEntities);
const alerts = type => createSelector(alertEntities, entities => Object.values(entities).filter(entity => entity.type === type));
const alertsFilteredByAlertId = (type, alertId) => createSelector(alertEntities, entities => Object.values(entities).filter(entity => entity.type === type && entity.uniqueAlertId === alertId));
const alertOrderMap = new Map([['error', 0], ['warning', 1], ['info', 2], ['success', 3]]);
const defaultVariant = 'warning';
const getOrderIndex = alertVariant => alertOrderMap.get(alertVariant || defaultVariant);
const order = alerts => {
  if (!!alerts && !alerts.length) {
    return alerts;
  }
  return alerts.sort((curr, next) => getOrderIndex(curr.alertData.variant) > getOrderIndex(next.alertData.variant) ? 1 : -1);
};
let AlertFacadeService = /*#__PURE__*/(() => {
  class AlertFacadeService {
    constructor(store) {
      this.store = store;
    }
    clearAlerts() {
      return this.store.dispatch(clearAlerts());
    }
    dismissAlert(id) {
      this.store.dispatch(deleteAlert({
        id
      }));
    }
    getAlerts$(type) {
      return this.store.pipe(select(alerts(type)), map(order));
    }
    getAlertByTypeAndKey$(type, key) {
      return this.getAlerts$(type).pipe(map(alerts => alerts.find(alert => alert.key === key && !alert.hide)));
    }
    getPageAlerts$(type, page) {
      return this.store.pipe(select(alertsFilteredByAlertId(type, `${page}_page_alert`)), map(alerts => isEmpty(alerts) ? null : alerts[0]));
    }
    hideAlert(key) {
      this.store.dispatch(updateAlert({
        id: key,
        changes: {
          hide: true
        }
      }));
    }
    unhideAlert(key) {
      this.store.dispatch(updateAlert({
        id: key,
        changes: {
          hide: false
        }
      }));
    }
    upsertAlert(alert) {
      this.store.dispatch(upsertAlert({
        alert
      }));
    }
    static {
      this.ɵfac = function AlertFacadeService_Factory(t) {
        return new (t || AlertFacadeService)(i0.ɵɵinject(i1.Store));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertFacadeService,
        factory: AlertFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AlertFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertStoreModule = /*#__PURE__*/(() => {
  class AlertStoreModule {
    static {
      this.ɵfac = function AlertStoreModule_Factory(t) {
        return new (t || AlertStoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AlertStoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, StoreModule.forFeature(alertsFeatureKey, alertReducer)]
      });
    }
  }
  return AlertStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AlertFacadeService, AlertStoreModule, AppAlertActionTypes, AppAlertType, adapter, alertEntities, alertReducer, alerts, alertsFeatureKey, alertsFilteredByAlertId, clearAlerts, deleteAlert, initialState, order, selectAlertState, selectEntities, updateAlert, upsertAlert, upsertAlerts };
